<template>
  <div class="logic-builder-component">
    <div class="modal-backdrop"></div>

    <div class="modal task">
      <div class="content logic-builder-component">
        <div class="pull-right">
          <div class="btn-close" v-if="!loading" @click="close()"></div>
        </div>

        <LogicBuilderComponent
          ref="logicComponentRef"
          :task="getFilteredInputTaskForLogicBuilder"
          :defaultStatementAndLogicNodes="
            this.task.props.defaultStatementAndLogicNodes
          "
          @onStatementOrLogicNodeChange="onStatementOrLogicNodeChange"
          v-show="!loading"
        ></LogicBuilderComponent>
      </div>
      <LoadingSpinner loadingCaption="Wird gespeichert..." v-show="loading" />
    </div>
  </div>
</template>

<script>
import { LogicBuilderComponent } from '@codelos.io/logic-builder';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import '@codelos.io/logic-builder/dist/logic-builder.css';

export default {
  name: 'logicBuilderWrap',

  props: {
    task: Object,
  },

  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async close() {
      const isCloseBtnDisabled =
        this.$refs.logicComponentRef.getIsBtnDisabled();

      if (!isCloseBtnDisabled) {
        this.loading = true;
        const output = this.$refs.logicComponentRef.getTaskOutput();

        if (output && output.length > 0) {
          this.task.output = [...output];
          this.$set(
            this.task,
            'output',
            this.task.output.concat(this.task.input)
          );
        } else {
          this.$set(this.task, 'output', this.task.input);
        }

        setTimeout(() => {
          this.loading = false;
          this.$emit('close');
        }, 1000);
      } else {
        this.$bvToast.toast(
          'Bitte führen Sie alle Regeln aus, um fortzufahren',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
          }
        );
      }
    },

    onStatementOrLogicNodeChange(event) {
      this.task.props.defaultStatementAndLogicNodes = event;
    },
  },

  computed: {
    getFilteredInputTaskForLogicBuilder() {
      const unwantedTypes = ['file'];
      const copyOfTask = JSON.parse(JSON.stringify(this.task));
      copyOfTask.input = copyOfTask.input.filter(
        (input) =>
          input.label !== 'codelosSettings' &&
          !unwantedTypes.includes(input.type)
      );
      return copyOfTask;
    },
  },

  components: {
    LogicBuilderComponent,
    LoadingSpinner,
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 80%;
  height: 98%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 0;
  position: absolute;
  left: 10%;
  top: 1%;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

.pull-right {
  float: right;
}

.btn-close {
  position: relative;
  z-index: 9;
  top: 10px;
  right: 5px;
  padding: 10px 10px;
}

.progress-icon-wrapper {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  text-align: center;
}

.progress-icon-wrapper .progress-icon {
  left: unset;
  margin: 0 auto;
  top: unset;
  margin-top: 30px;
}
.progress-icon-wrapper .progress-icon:after {
  border-color: #313745 transparent #313745 transparent;
}

/*New added*/

::v-deep .logic-builder-component * {
  box-sizing: border-box;
}
.logic-builder-component .logic-builder-main-wrap {
  box-shadow: none;
  border: none;
}

::v-deep .logic-builder-component .dropdown-menu.show {
  bottom: unset;
  min-width: 150px;
  box-sizing: border-box;
}
::v-deep .logic-builder-component .dropdown-item {
  box-sizing: border-box;
}
::v-deep a.dropdown-item span {
  line-height: 24px;
  display: inline-block;
}

::v-deep .logic-builder-component .new-rule-header .new-rule-title-wrap {
  color: #333137;
}

::v-deep .logic-builder-component .collapse {
  width: auto !important;
}

::v-deep .logic-builder-component .conditionStatement-builder-inner fieldset {
  border: 1px dashed rgb(0 0 0 / 36%);
}
::v-deep
  .logic-builder-component
  .conditionStatement-builder-dropdown
  .input-wrap
  .icon {
  top: calc(50% - 0px);
}
::v-deep .logic-builder-component .conditionStatement-and-or-buttons li button {
  font-size: 16px;
}

::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}
.conditionStatement-builder .title-wrap ::v-deep .setRulesBtn {
  height: 38px;
}

.rule-btn-wrap {
  display: flex;
  align-items: center;
}
::v-deep .logic-builder-component .operator-selection select {
  line-height: normal;
}
::v-deep .logic-builder-component .conditionStatement-and-or-buttons {
  font-size: 16px;
  color: #000;
  position: relative;
  top: -8px;
}
::v-deep .logic-builder-component .inline,
::v-deep .logic-builder-component .delete-rule {
  color: #2c3e50;
}
::v-deep .logic-builder-component .add-new-input {
  font-size: 16px;
}
::v-deep .logic-builder-component .when-rule-inner .pl-4 {
  height: auto;
}

::v-deep .remove-condition-block svg {
  font-size: 20px;
  color: #323338;
}
</style>
